function getDefaultState() {
    return {
        // ... 业务系统的 state 写在下方
    };
}

const state = getDefaultState();

const mutations = {};
const actions = {};
const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
